import React from 'react';
import { Switch, FormControlLabel, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import * as Funciones from '../../../global/js/funciones';
import { actualizarMensaje } from '../../../redux/actions/actGlobal';

/**
 * Control obligatorio para el profesor:
 * "¿Tiene disponibilidad para recibir nuevos estudiantes en su grupo de semillero?"
 *  - "1" = Sí  -> el semillero aparece en la oferta para estudiantes
 *  - "0" = No  -> el semillero NO aparece para estudiantes, pero sigue visible para la coordinación
 *
 * Guarda de inmediato vía PATCH investigacion/semillero/disponibilidad/<id>.
 *
 * props:
 *  - semillero: objeto del semillero (usa semillero.id y semillero.disponibilidad)
 *  - onCambio(idSemillero, nuevoValor): opcional, para que el padre sincronice su lista
 *  - mostrarEtiqueta: bool (default true)
 */
const SwitchDisponibilidadSemillero = ({ semillero, onCambio, mostrarEtiqueta = true }) => {
  const dispatch = useDispatch();
  const idSemillero = semillero && (semillero.id || (semillero.semillero && semillero.semillero.id));
  const inicial = semillero && semillero.disponibilidad === '0' ? '0' : '1';
  const [valor, setValor] = React.useState(inicial);
  const [guardando, setGuardando] = React.useState(false);

  React.useEffect(() => {
    setValor(semillero && semillero.disponibilidad === '0' ? '0' : '1');
  }, [idSemillero, semillero && semillero.disponibilidad]);

  const handleChange = (event) => {
    if (!idSemillero) return;
    const nuevo = event.target.checked ? '1' : '0';
    const anterior = valor;
    setValor(nuevo);
    setGuardando(true);
    Funciones.consulta(
      `api/v1.0/investigacion/semillero/disponibilidad/${idSemillero}`,
      { disponibilidad: nuevo },
      'PATCH',
      (error, estado, resp) => {
        setGuardando(false);
        if (!error && estado === 200) {
          if (typeof onCambio === 'function') onCambio(idSemillero, nuevo);
          dispatch(actualizarMensaje({
            titulo: nuevo === '1'
              ? 'El semillero queda visible en la oferta para estudiantes'
              : 'El semillero deja de aparecer en la oferta para estudiantes',
            tipo: 'success', mostrar: true, tiempo: 6000,
          }));
        } else {
          setValor(anterior);
          dispatch(actualizarMensaje({
            titulo: (resp && resp.titulo) || 'No se pudo actualizar la disponibilidad',
            tipo: 'info', mostrar: true, tiempo: 6000,
          }));
        }
      }
    );
  };

  return (
    <Tooltip title="¿Tiene disponibilidad para recibir nuevos estudiantes en su grupo de semillero?" arrow>
      <FormControlLabel
        style={{ marginRight: 0 }}
        control={<Switch checked={valor === '1'} onChange={handleChange} disabled={guardando} color="primary" size="small" />}
        label={mostrarEtiqueta ? <span style={{ fontSize: 12 }}>{valor === '1' ? 'Disponible' : 'No disponible'}</span> : null}
      />
    </Tooltip>
  );
};

export default SwitchDisponibilidadSemillero;
